import { render, staticRenderFns } from "./TextAbbr.vue?vue&type=template&id=1bbfcdff&"
import script from "./TextAbbr.vue?vue&type=script&lang=js&"
export * from "./TextAbbr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports